import PersonBase from './row_ml'
import imgEffects from './imgEffects'

export default class Person_J_Templet extends PersonBase {
  constructor(...args) {
    super(...args)
  }

  // 显示分页数据
  pageShowList(list, page, currentPage) {
    let listArr = JSON.parse(JSON.stringify(list))
    let arr = []
    if (page.radioValue) {
      if (page.pageStyle === 0 || page.pageStyle === 1) {
        arr = listArr.splice(page.pageSize * (currentPage - 1), page.pageSize)
      }
      if (page.pageStyle === 2) {
        arr = listArr.slice(0, page.pageSize * currentPage)
      }
    } else {
      arr = listArr
    }
    return arr
  }

  initImageAnimation(animate, img_effects, dom, platform) {
    if (platform === 'mb') {
      return
    }
    // 特效类型绑定
    img_effects.id = animate.id
    img_effects.formData = animate.formData

    // 清空所有绑定样式
    imgEffects.clearAll(dom)

    // 无
    if (img_effects.type === 0) {
      this.clear_animation(dom)
    }
    // 放大
    if (img_effects.id === 1) {
      // 特效1
      if (img_effects.formData.effect === 0) {
        imgEffects.type1effect0(dom)
      }
      // 特效2
      if (img_effects.formData.effect === 1) {
        imgEffects.type1effect1(dom)
      }
    }
    // 边框特效
    if (img_effects.id === 2) {
      // 特效1
      if (img_effects.formData.effect === 0) {
        imgEffects.type2effect0(dom)
      }
      // 特效2
      if (img_effects.formData.effect === 1) {
        imgEffects.type2effect1(dom)
      }
      // 特效3
      if (img_effects.formData.effect === 2) {
        imgEffects.type2effect2(dom)
      }
      // 特效4
      if (img_effects.formData.effect === 3) {
        imgEffects.type2effect3(dom)
      }
    }
    // 位移
    if (img_effects.id === 3) {
      // 特效1
      if (img_effects.formData.direction === 'left') {
        imgEffects.type3effect0(dom)
      }
      if (img_effects.formData.direction === 'right') {
        imgEffects.type3effect1(dom)
      }
      if (img_effects.formData.direction === 'top') {
        imgEffects.type3effect2(dom)
      }
      if (img_effects.formData.direction === 'bottom') {
        imgEffects.type3effect3(dom)
      }
    }
    // 缩小
    if (img_effects.id === 4) {
      if (img_effects.formData.effect === 0) {
        imgEffects.type4effect0(dom, img_effects)
      }
      if (img_effects.formData.effect === 1) {
        imgEffects.type4effect1(dom, img_effects)
      }
    }
    // 放大镜
    if (img_effects.id === 5) {
      imgEffects.type5effect0(dom)
    }
  }
  // 切换图片特效
  changeImageAnimation(animate, img_effects, dom) {
    this.initImageAnimation(animate, img_effects, dom)
    this.play_animation(dom, 'image_animation', img_effects)
  }
  // 移入特效
  enter_animation(img_effects, dom, platform) {
    if (platform === 'mb') {
      return
    }
    // 放大特效
    if (img_effects.id === 1) {
      // 特效2
      if (img_effects.formData.effect === 1) {
        this.play_animation(dom)
      }
    }
    // 边框特效
    if (img_effects.id === 2) {
      // 特效1
      if (img_effects.formData.effect === 0) {
        imgEffects.type2effect0Enter(dom, img_effects)
      }
      // 特效2
      if (img_effects.formData.effect === 1) {
        imgEffects.type2effect1Enter(dom, img_effects)
      }
      // 特效3
      if (img_effects.formData.effect === 2) {
        imgEffects.type2effect2Enter(dom, img_effects)
      }
      // 特效4
      if (img_effects.formData.effect === 3) {
        imgEffects.type2effect3Enter(dom, img_effects)
      }
    }
    // 放大镜特效
    if (img_effects.id === 5) {
      imgEffects.type5effect0Enter(dom, img_effects)
    }
  }
  // 移出特效
  leave_animation(img_effects, dom) {
    // 边框特效
    if (img_effects.id === 2) {
      // 特效1
      if (img_effects.formData.effect === 0) {
        imgEffects.type2effect0Leave(dom)
      }
      // 特效2
      if (img_effects.formData.effect === 1) {
        imgEffects.type2effect1Leave(dom)
      }
      // 特效3
      if (img_effects.formData.effect === 2) {
        imgEffects.type2effect2Leave(dom)
      }
      // 特效4
      if (img_effects.formData.effect === 3) {
        imgEffects.type2effect3Leave(dom)
      }
    }
    // 放大镜特效
    if (img_effects.id === 5) {
      imgEffects.type5effect0Leave(dom, img_effects)
    }
  }
  // 播放特效
  play_animation(dom, animateType, animate) {
    imgEffects.playEffect(dom, animateType, animate)
  }

  // 检查补充无分页情况下的显示数量问题
  checkShowValue(typeValue) {
    if (typeof typeValue.showAll == 'undefined') {
      this.p_$set(typeValue, 'showAll', true)
    }
    if (typeof typeValue.showNum == 'undefined') {
      this.p_$set(typeValue, 'showNum', 1)
    }
  }
    // 检查补充无缩略图宽度的问题
    checkThumbnailWidth(typeValue,parent_w,img_w=null) {
      let width = ''
      if(parent_w) {
        const box_w = $(window).width();
        width = parseInt(parent_w/box_w*1920) + 150
        if(img_w !== null && width < 600) {
          width = 600
        }
        if((img_w && width > img_w) || width > 1500) {
          width = ''
        }
      }
      // console.log('width:',width)
      this.p_$set(typeValue, 'thumbnailWidth', width)
    }
}


// WEBPACK FOOTER //
// ./src/base/row_lolo.js